export function cleanUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!url) {
    return '';
  }

  if (isUrlAnEmail(url)) {
    return "mailto:".concat(url.replace('mailto:', ''));
  }

  if (!urlHasProtocol(url)) {
    return "http://".concat(url);
  }

  return url;
}
export function isUrlAnEmail(url) {
  return url.includes('@') && !urlHasProtocol(url);
}
export function urlHasProtocol(url) {
  return url.indexOf('://') !== -1;
}